import { ChartFeature } from '../chart-props';
import { Source } from './source';

export type FeatureState = Record<string, any>;
export class VectorSource extends Source {
    private features: ChartFeature[] = [];

    constructor(public readonly id: string) {
        super();
    }

    setData(features: ChartFeature[]) {
        this.features = features;
    }

    getData() {
        return this.features;
    }

    hasData() {
        return this.features.length > 0;
    }

    getBoundsX() {
        return this.getBounds('x');
    }

    getBoundsY() {
        return this.getBounds('y');
    }

    private getBounds(dir: 'x' | 'y'): { min: number; max: number } {
        if (!this.hasData()) {
            return { min: 0, max: 1 };
        }

        let currentMax = -Infinity;
        let currentMin = Infinity;

        for (const feature of this.getData()) {
            switch (feature.geometry.type) {
                case 'Line':
                    currentMax = Math.max(
                        currentMax,
                        feature.geometry.coordinates.reduce((p, n) => (p > n[dir === 'x' ? 0 : 1] ? p : n[dir === 'x' ? 0 : 1]), 0)
                    );
                    currentMin = Math.min(
                        currentMax,
                        feature.geometry.coordinates.reduce((p, n) => (p < n[dir === 'x' ? 0 : 1] ? p : n[dir === 'x' ? 0 : 1]), 0)
                    );

                    break;
                case 'Point':
                    currentMax = Math.max(currentMax, feature.geometry.coordinates[dir === 'x' ? 0 : 1]);
                    currentMin = Math.min(currentMin, feature.geometry.coordinates[dir === 'x' ? 0 : 1]);
                    break;
                // TODO: polygon?
            }
        }

        return { min: currentMin, max: currentMax };
    }
}
